export type ObjectConstructorLike = {
    hasOwn?: (object: unknown, key: PropertyKey) => boolean;
};

/**
 * Safari < 15.4 and old Chromium WebViews lack Object.hasOwn, which
 * es-toolkit (bundled through @inertiajs/core) calls while the app boots.
 * Vite's build target only transpiles syntax and never adds missing APIs, so
 * this is polyfilled by hand. Importing the module installs it.
 */
export function polyfillObjectHasOwn(
    target: ObjectConstructorLike = Object as ObjectConstructorLike,
): void {
    if (typeof target.hasOwn === 'function') {
        return;
    }

    Object.defineProperty(target, 'hasOwn', {
        value: function hasOwn(object: unknown, key: PropertyKey): boolean {
            if (object === null || object === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            return Object.prototype.hasOwnProperty.call(Object(object), key);
        },
        configurable: true,
        writable: true,
        enumerable: false,
    });
}

polyfillObjectHasOwn();
